import { useCallback, useState } from 'react';

const knowHowFormPostPath = '/know_how_request/';
const knwoHowFormThanksPath = '/knowledge/thanks/';

export const useKnowHowForm = () => {
  const [emailTaken, setEmailTaken] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState<string>();

  return {
    onSubmit: useCallback(
      async (ev: React.FormEvent<HTMLFormElement>) => {
        const submitButton = ev.currentTarget.querySelector('button');
        if (submitButton) {
          submitButton.disabled = true;
        }
        ev.preventDefault();
        try {
          const fd = new FormData(ev.target as any);
          fd.append('form_url', location.href);

          const res = await fetch(knowHowFormPostPath, {
            body: fd,
            method: 'POST',
          });

          if (res.ok) {
            window.location.href = knwoHowFormThanksPath;
            return;
          }

          const responseBody: { errorMessage?: string; emailTaken?: boolean } =
            await res.json();

          setEmailTaken(responseBody.emailTaken);
          setErrorMessage(
            // email登録済みエラー以外を表示
            !responseBody.emailTaken ? responseBody.errorMessage : undefined
          );
        } catch (e) {
          setErrorMessage(`エラーのため問い合わせができませんでした: ${e}`);
        } finally {
          if (submitButton) {
            submitButton.disabled = false;
          }
        }
      },
      [setEmailTaken, setErrorMessage]
    ),
    emailTaken,
    errorMessage,
  };
};
